import React, { useEffect, useRef, useState } from "react";
import AccountSettingSidebar from "../../../../component/common/layout/AccountSettingSidebar";
import LeftSidebarNew from "../../../../component/common/layout/LeftSidebarNew";
import SurveyListHeader from "../../../../component/common/layout/SurveyListHeader";
import Svg from "../../../../component/common/Svg";
import Input from "../../../../core/Inputs/DefaultInput";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import SurveyListSidebar from "../../../../component/common/layout/SurveyListSidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { addTeamMemberSchema, editTeamSchema } from "../../../../schema/team";
import { useDispatch, useSelector } from "react-redux";
import { getTokenData } from '../../../../store/actions/authAction';
import {
  addTeamMember,
  deleteTeamMember,
  editTeam,
  getTeamDetail,
} from "../../../../store/actions/teamAction";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { getUserList } from "../../../../store/actions/userActions";
import { getRoleList } from "../../../../store/actions/roleAction";
import Card from "../../../../core/Card/Card";
import style from "../../../style.module.css";
import NestedMenuToggle from "../NestedMenuToggle";


import { useTranslation } from 'react-i18next';
import { getCountryCodes } from "../../../../store/actions/locationActions";

const options = [
  { value: "Sam Adams", label: "Sam Adams" },
  { value: "Tim Mayers", label: "Tim Mayers" },
  { value: "John Doe", label: "John Doe" },
];

export default function Edit() {
  const { t, i18n } = useTranslation();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    teamDataLoading,
    teamData: teamList,
    teamDetail: teamDetail,
    teamMembers: teamMembers,
    totalRecords,
    isAddingTeam,
    isDeleteUser,
  } = useSelector((state) => state.teamData);
  const { userData } = useSelector((state) => state.userData);
  const { roleData: roleList } = useSelector((state) => state.roleData);
  const { countryCodesData } = useSelector((state) => state.locationData);

  const [filteredUserList, setFilteredUserList] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [userId, setuserId] = useState('');



  const isTeamAdmin = teamMembers.some(
  (member) => member.user_id === userId && member.role_name === "Admin"
  );

  console.log("isTeamAdmin--",isTeamAdmin);

const handleRoleChange = async (member, newRoleId) => {
  if (member.role_id === newRoleId) return;

  await dispatch(
    deleteTeamMember({
      team_member_id: member.user_id,
      team_id: location.state.teamId,
    })
  );

  await dispatch(
    addTeamMember({
      team_id: location.state.teamId,
      team_member_id: member.user_id,
      role_id: newRoleId,
    })
  );

  fetchTeamDetail(location.state.teamId);
};


  const fetchTeamDetail = async (teamId) => {
    if (teamDataLoading) return;
    let payload = {
      team_id: teamId,
    };
    dispatch(getTeamDetail(payload));
  };
  const getUsers = async () => {
    console.log("here");
    let payload = { startingLimit: 0, resultsPerPage: 1000, search: "" };
    dispatch(getUserList(payload));
  };

  const getRoles = () => {
    const payload = {
      startingLimit: 0,
      resultsPerPage: 8,
      search: "",
    };
    dispatch(getRoleList(payload));
  };

  const deleteUserData = async () => {
    const payload = { team_member_id: deleteUserId, team_id: location.state.teamId };
    const result = await dispatch(deleteTeamMember(payload));
    if (result?.success) {
      toast.success(result.msg || "Team member removed successfully");
    } else {
      toast.error(result?.msg || "Failed to remove team member");
    }
  };

  useEffect(() => {
    if (!isDeleteUser) {
      let deleteUser = document.getElementById("deleteTeamMemberModal");
      let deleteUserModal =
        window.bootstrap.Modal.getOrCreateInstance(deleteUser);
      if (deleteUserModal && deleteUserModal._isShown) {
        deleteUserModal.hide();
      }
      fetchTeamDetail(location.state.teamId);
    }
  }, [isDeleteUser]);

  useEffect(() => {
    let teamMemberIds = teamMembers.map((e) => e.user_id);
    let userOptions = userData.map((ele) => {
      return { value: ele.id, label: ele.name };
    });
    setFilteredUserList(
      userOptions.filter((e) => !teamMemberIds.includes(e.value))
    );
  }, [teamMembers]);

  useEffect(() => {
    let teamMemberIds = teamMembers.map((e) => e.user_id);
    let userOptions = userData.map((ele) => {
      return { value: ele.id, label: ele.name };
    });
    setFilteredUserList(
      userOptions.filter((e) => !teamMemberIds.includes(e.value))
    );
  }, [userData]);

  useEffect(() => {
    let options = [];
    console.log("roleList", roleList);
    roleList.map((ele) => {
      options.push({ value: ele.id, label: ele.role_name });
    });
    setRoleOptions(options);
  }, [roleList]);

  useEffect(() => {
    if (location.state && location.state.teamId) {
      fetchTeamDetail(location.state.teamId);
    }
  }, [location]);

  useEffect(() => {
    if (!isAddingTeam) {
      fetchTeamDetail(location.state.teamId);
    }
  }, [isAddingTeam]);

  useEffect(() => {
    getUsers();
    getRoles();
    dispatch(getCountryCodes());
  }, []);

  useEffect(() => {
    setCurrentTeam(teamDetail);
     // Optional: sort members alphabetically by name
     if (teamMembers.length) {
  teamMembers.sort((a, b) =>
  (a?.user_name ?? "").localeCompare(b?.user_name ?? "")
);

  }
  }, [teamDetail]);

  useEffect(() => {
  dispatch(getTokenData(setuserId));
}, [userId, dispatch]);
  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
        <SurveyListHeader />
        <div id="viewport" className="d-flex bg-white">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 page-content-wrap d-flex flex-column">
              <div className="page-heading">
                {/* breadcrumbs here */}
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">{t('settings.title')}</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/user-permissions">{t('settings.users_and_teams.breadcrumb_heading')}</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/teams/list">{t('settings.team.heading')}</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>{t('settings.team.action.edit_team')}</strong>
                    </li>
                  </ol>
                </nav>
                {/* breadcrumbs ends here */}
                {/* breadcrumbs ends here */}
                <div className="d-flex align-items-center">
                  <NestedMenuToggle />
                  <div className="flex-grow-1 ps-3 ps-lg-0">
                    <h1>{t('settings.team.action.edit_team')}
                    </h1>
                  </div>
                </div>
              </div>
              <div className="role-wrapper flex-grow-1">
                <Formik
                  innerRef={formikRef}
                  initialValues={{
                    team_id:
                      location.state && location.state.teamId
                        ? location.state.teamId
                        : "",
                    team_name: teamDetail && teamDetail.team_name,
                    country: (teamDetail && teamDetail.country) || "",
                    country_code: (teamDetail && teamDetail.country_code) || "",
                  }}
                  enableReinitialize
                  validationSchema={editTeamSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    const dataToSend = {
                      team_name: values.team_name,
                      team_id: values.team_id,
                      country: values.country,
                      country_code: values.country_code,
                    };
                    try {
                      const result = await dispatch(editTeam(dataToSend));
                      if (result?.success) {
                        toast.success(result.msg || "Team updated successfully");
                        fetchTeamDetail(values.team_id);
                      } else {
                        toast.error(result?.msg || "Failed to update team");
                      }
                    } catch {
                      toast.error("Failed to update team");
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    resetForm,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="create-team-form">
                        <div className="row">
                          <div className="col-lg-6 position-relative">
                            <div className="form-group mb-3">
                              <label className="form-label-custom">{t('settings.team.action.team_name')}<span className="text-primary">*</span>
                              </label>
                              <Input
                                type="text"
                                view="outlined"
                                dense={false}
                                color="default"
                                label=""
                                name="team_name"
                                placeholder={t('settings.team.action.team_name')}
                                clearButton={true}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                defaultValue={values.team_name}
                                value={values.team_name}
                                onChange={handleChange}
                              />
                            </div>
                            {touched.team_name && errors.team_name && (
                              <div className="validation-msg">
                                {errors.team_name}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 position-relative">
                            <div className="form-group mb-3">
                              <label className="form-label-custom">Country<span className="text-primary">*</span></label>
                              <select
                                name="country"
                                className="form-control formsinput"
                                value={values.country}
                                onChange={(e) => {
                                  const selectedName = e.target.value;
                                  setFieldValue("country", selectedName);
                                  const match = Array.isArray(countryCodesData)
                                    ? countryCodesData.find((c) => c.name === selectedName)
                                    : null;
                                  setFieldValue("country_code", match ? `+${match.countrycode}` : "");
                                }}
                                onBlur={handleBlur}
                              >
                                <option value="">Select Country</option>
                                {Array.isArray(countryCodesData) &&
                                  countryCodesData
                                    .slice()
                                    .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                                    .map((c, idx) => (
                                      <option key={`${c.name}-${c.alpha2}-${idx}`} value={c.name}>
                                        {c.name}
                                      </option>
                                    ))}
                              </select>
                            </div>
                            {touched.country && errors.country && (
                              <div className="validation-msg">
                                {errors.country}
                              </div>
                            )}
                          </div>
                          <div className="col-lg-6 position-relative">
                            <div className="form-group mb-3">
                              <label className="form-label-custom">Country Code</label>
                              <input
                                type="text"
                                className="form-control formsinput"
                                name="country_code"
                                value={values.country_code}
                                readOnly
                                placeholder="Auto-filled"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="button-wrap d-flex">
                          <button type="submit" className="btn btn-primary">
                            {t('settings.team.action.save')}

                          </button>
                          {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                          {/* <button type="button" className="btn btn-primary">Save</button> */}
                          <button
                            onClick={() => {
                              resetForm();
                            }}
                            type="button"
                            className="btn btn-bordered ms-3"
                          >
                            {t('settings.team.action.cancel')}

                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
                <Formik
                  initialValues={{
                    team_id:
                      location.state && location.state.teamId
                        ? location.state.teamId
                        : "",
                    user_id: "",
                    role_id: "",
                  }}
                  enableReinitialize
                  validationSchema={addTeamMemberSchema}
                  onSubmit={async (values, { setSubmitting, resetForm }) => {
                    const dataToSend = {
                      team_id: values.team_id,
                      team_member_id: values.user_id,
                      role_id: values.role_id,
                    };
                    try {
                      const result = await dispatch(addTeamMember(dataToSend));
                      if (result?.success) {
                        toast.success(result.msg || "Team member added successfully");
                        resetForm();
                        fetchTeamDetail(values.team_id);
                      } else {
                        toast.error(result?.msg || "Failed to add team member");
                      }
                    } catch {
                      toast.error("Failed to add team member");
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    resetForm,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      {console.log("errors", errors)}
                      <div className="row pt-3">
                        <div className="col-lg-6 position-relative">
                          <div className="form-group mb-3 cstom-select">
                            <label className="form-label-custom">{t('settings.team.action.add_member')}<span className="text-primary">*</span>
                            </label>
                            <Select
                              placeholder={t('settings.team.action.add_member')}
                              //isClearable
                              value={
                                values.user_id
                                  ? filteredUserList.find(
                                    (option) =>
                                      option.value === values.user_id
                                  )
                                  : null
                              }
                              options={filteredUserList}
                              onChange={(v) => {
                                setFieldValue("user_id", v.value || '');
                              }}
                              onMenuOpen={() => setFieldTouched("user_id", false)}
                              onBlur={() => setFieldTouched("user_id", true)}
                            />
                          </div>
                          {touched.user_id && errors.user_id && (
                            <div className="validation-msg">
                              {errors.user_id}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-6 position-relative">
                          <div className="form-group mb-3 cstom-select">
                            <label className="form-label-custom">{t('settings.team.action.select_role')}<span className="text-primary">*</span>
                            </label>
                            <Select
                              placeholder={t('settings.team.action.select_role')}
                              //isClearable
                              value={
                                values.role_id
                                  ? roleOptions.find(
                                    (option) =>
                                      option.value === values.role_id
                                  )
                                  : null
                              }
                              options={roleOptions}
                              onChange={(v) => {
                                setFieldValue("role_id", v.value || '');
                              }}
                              onMenuOpen={() => setFieldTouched("role_id", false)}
                              onBlur={() => setFieldTouched("role_id", true)}
                            />
                          </div>
                          {touched.role_id && errors.role_id && (
                            <div className="validation-msg">
                              {errors.role_id}
                            </div>
                          )}
                        </div>
                        <div className="button-wrap d-flex pt-3">
                          <button type="submit" className="btn btn-primary">
                            {t('settings.team.action.save')}

                          </button>
                          {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                          {/* <button type="button" className="btn btn-primary">Save</button> */}
                          <button
                            type="button"
                            onClick={() => {
                              resetForm();
                            }}
                            className="btn btn-bordered color-cancel ms-3"
                          >
                            {t('settings.team.action.cancel')}

                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
                {/* if there are added users */}
                <div className="col-lg-12">
                  <div className="form-group mt-3 mb-3 create-team-form">
                    <h2>{t('settings.team.action.added_members')}
                    </h2>
                    <div className="user-list">
                      {teamMembers.length > 0 &&
                        teamMembers.map((member, memberIndex) => (
                          <div
                            className="list-item d-flex align-items-center gap-3"
                            key={memberIndex}
                          >
                            <div className="flex-grow-1 name">
                              {member.user_name ? member.user_name : "-"}
                              {currentTeam && currentTeam.added_by === member.user_id && (
                                <span className="default"> {t('settings.team.action.owner')}</span>
                              )}
                            </div>
                            {/* <div className="role">
                              {member.role_name ? member.role_name : "-"}
                            </div> */}


                            <div className="role">
                              <Select
                               // classNamePrefix="role-select"
                                options={roleOptions}
                                value={roleOptions.find(o => o.value === member.role_id)}
                                isSearchable={false}
                                onChange={opt => handleRoleChange(member, opt.value)}
                                isDisabled={!isTeamAdmin}
                                
                              />
                            </div>


                            <a
                              data-bs-toggle="modal"
                              data-bs-target="#deleteTeamMemberModal"
                              onClick={() => setDeleteUserId(member.user_id)}
                              className="action-btn"
                            >
                              {" "}
                              <Svg name="table-delete" />{" "}
                            </a>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteTeamMemberModal"
        tabIndex={-1}
        aria-labelledby="deleteTeamMemberModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t('settings.roles.delete_action.heading')}</h3>
                        <p>
                          {t('settings.users_and_teams.users.delete_action.text1')}{" "}
                        </p>
                      </div>
                      <div className="warning-message">
                        <div className="title d-flex align-items-center">
                          <svg
                            width={40}
                            height={42}
                            viewBox="0 0 40 42"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 2L37.3205 32H2.67949L20 2Z"
                              stroke="#F05454"
                              strokeWidth={3}
                              strokeLinejoin="round"
                            />
                            <path
                              d="M20 13.5385V22"
                              stroke="#F05454"
                              strokeWidth={3}
                            />
                            <circle
                              cx="19.9994"
                              cy="25.8461"
                              r={1}
                              fill="black"
                              stroke="#F05454"
                              strokeWidth="1.07692"
                            />
                          </svg>
                          <h4>{t('settings.users_and_teams.users.delete_action.sub_heading')}</h4>
                        </div>
                        <p>
                          {t('settings.users_and_teams.users.delete_action.text2')}
                        </p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered color-delete"
                          data-bs-dismiss="modal"
                        >
                          {t('settings.team.action.cancel')}

                        </button>
                        <button
                          type="button"
                          className="btn btn-delete ms-3"
                          onClick={() => deleteUserData()}
                        >
                          {t('settings.team.action.delete.confirm_delete')}

                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
